import { Guide } from '../../types/guide';

const guide: Guide = {
  slug: 'how-to-merge-pdf-files-for-free',
  title: 'How to Merge PDF Files for Free',
  description:
    'Combine multiple PDFs into a single file for free, entirely in your browser — no upload, no watermark, no account required.',
  category: 'PDF tools',
  publishedDate: '2026-08-06',
  affiliateCategory: 'general',
  body: `
Combining a stack of PDFs — scanned receipts, chapter files, signed contracts — into one document is one of those tasks that shouldn't require installing software or uploading sensitive files to a random website. Here's how to do it for free, in your browser.

## Steps

1. **Open [pdf-to-text.com](https://pdf-to-text.com)** and upload each PDF you want to combine. They'll appear in the file list on the left.
2. **Select the files to merge.** Check the box next to each PDF you want included, in the order you want them combined.
3. **Open the "PDF Tools" panel** below the output area and expand it.
4. **Click "Merge."** The tool combines the selected PDFs into one file, in list order, and downloads it as \`merged-<date>.pdf\`.

## Why this works entirely offline

The merge tool uses [pdf-lib](https://pdf-lib.js.org/), a PDF-manipulation library that runs in JavaScript, directly in your browser. Your files are read, combined, and written back out to a downloadable blob without ever leaving your device — nothing is uploaded to a server, which matters if the documents contain anything sensitive.

## Other PDF tools worth knowing about

The same "PDF Tools" panel also supports:
- **Extract / split pages** — pull a page range (e.g. \`1-3, 5\`) out into a new PDF.
- **Reorder pages** — rearrange pages within a single PDF using a full permutation (e.g. \`3, 1, 2\`).
- **Export pages as images** — render individual pages to PNG or JPEG at screen, high, or print resolution.

All of them follow the same pattern: select or open a PDF, configure the operation, and download the result — no uploads involved.
`,
};

export default guide;
